import { useEffect, useState } from 'react';
export const useImageToBase64 = (url) => {
    const [loading, setLoading] = useState(true);
    const [image, setImage] = useState(null);
    const imageFetch = window.fetch;
    useEffect(() => {
        setLoading(true);
        imageFetch(url)
            .then(response => response.blob())
            .then(data => {
            const reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onloadend = () => {
                const base64data = reader.result;
                setLoading(false);
                setImage(base64data);
            };
        });
    }, [url]);
    return { href: image, loading };
};
//# sourceMappingURL=image-to-base64.js.map